export default "__VITE_ASSET__CKKS5Vom__"